import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { hasModuleAccess, hasAnyPermission, hasPermission } from '../../utils/permissions';

import styles from './styles.module.scss';

const Sidebar = () => {
  const location = useLocation();
  const activeItem = location.pathname;

  const showReports = hasModuleAccess('reports');
  const showComercial = hasAnyPermission([
    'clients.list', 'leads.list', 'offers.list', 'quotations.list', 'sales.view',
  ]);
  const showInventario = hasAnyPermission([
    'items.list', 'items.create', 'item_storage.view',
  ]);
  const showConfig = hasAnyPermission([
    'categories.list', 'colors.list', 'comments.list', 'providers.list',
    'brands.list', 'users.list', 'settings.view', 'banners.list',
    'faqs.list', 'services.list', 'blogs.list', 'roles.list',
  ]);

  return (
    <div className={styles.sidebar}>
      <Nav vertical className={styles.nav}>
        <NavItem
          className={`${styles.navItem} ${
            activeItem === '/' ? styles.active : ''
          }`}
        >
          <NavLink tag={RouterLink} to="/">Inicio</NavLink>
        </NavItem>

        {showReports && (
          <NavItem
            className={`${styles.navItem} ${
              activeItem === '/report' ? styles.active : ''
            }`}
          >
            <NavLink tag={RouterLink} to="/report">Reportes</NavLink>
          </NavItem>
        )}

        {showComercial && (
          <>
            <UncontrolledDropdown
              nav
              inNavbar
              className={`${styles.navItem} ${
                activeItem === '/comercial' ? styles.active : ''
              }`}
            >
              <DropdownToggle nav caret>
                Comercial
              </DropdownToggle>
              <DropdownMenu>
                {hasPermission('clients.list') && (
                  <DropdownItem
                    tag={RouterLink}
                    to="/client-list"
                    className={activeItem === '/client-list' ? styles.active : ''}
                  >
                    Clientes
                  </DropdownItem>
                )}
                {hasPermission('clients.create') && (
                  <DropdownItem
                    tag={RouterLink}
                    to="/client-form"
                    className={activeItem === '/client-form' ? styles.active : ''}
                  >
                    Crear cliente
                  </DropdownItem>
                )}
                {hasPermission('leads.list') && (
                  <DropdownItem
                    tag={RouterLink}
                    to="/lead-board"
                    className={activeItem === '/lead-board' ? styles.active : ''}
                  >
                    Leads
                  </DropdownItem>
                )}
                {hasPermission('offers.list') && (
                  <DropdownItem
                    tag={RouterLink}
                    to="/offerlist"
                    className={activeItem === '/offerlist' ? styles.active : ''}
                  >
                    Ofertas
                  </DropdownItem>
                )}
                {hasPermission('quotations.list') && (
                  <DropdownItem
                    tag={RouterLink}
                    to="/quotationlist"
                    className={
                      activeItem === '/quotationlist' ? styles.active : ''
                    }
                  >
                    Cotización
                  </DropdownItem>
                )}
                {hasPermission('sales.view') && (
                  <DropdownItem
                    tag={RouterLink}
                    to="/sales"
                    className={activeItem === '/sales' ? styles.active : ''}
                  >
                    Ventas
                  </DropdownItem>
                )}
              </DropdownMenu>
            </UncontrolledDropdown>
          </>
        )}

        {showInventario && (
          <>
            <UncontrolledDropdown
              nav
              inNavbar
              className={`${styles.navItem} ${
                activeItem === '/inventario' ? styles.active : ''
              }`}
            >
              <DropdownToggle nav caret>
                Inventario
              </DropdownToggle>
              <DropdownMenu>
                {hasPermission('items.list') && (
                  <DropdownItem
                    tag={RouterLink}
                    to="/items"
                    className={activeItem === '/items' ? styles.active : ''}
                  >
                    Bienes
                  </DropdownItem>
                )}
                {hasPermission('items.list') && (
                  <DropdownItem
                    tag={RouterLink}
                    to="/list-items"
                    className={activeItem === '/list-items' ? styles.active : ''}
                  >
                    Revisar Actas
                  </DropdownItem>
                )}
                {hasPermission('items.create') && (
                  <DropdownItem
                    tag={RouterLink}
                    to="/create-items"
                    className={
                      activeItem === '/create-items' ? styles.active : ''
                    }
                  >
                    Ingresar Bien
                  </DropdownItem>
                )}
                {hasPermission('item_storage.view') && (
                  <DropdownItem
                    tag={RouterLink}
                    to="/item-storage"
                    className={
                      activeItem === '/item-storage' ? styles.active : ''
                    }
                  >
                    Bodegaje
                  </DropdownItem>
                )}
              </DropdownMenu>
            </UncontrolledDropdown>
          </>
        )}

        {showConfig && (
          <UncontrolledDropdown
            nav
            inNavbar
            className={`${styles.navItem} ${
              activeItem === '/configuracion' ? styles.active : ''
            }`}
          >
            <DropdownToggle nav caret>
              Configuración
            </DropdownToggle>
            <DropdownMenu>
              {hasPermission('categories.list') && (
                <DropdownItem
                  tag={RouterLink}
                  to="/category"
                  className={activeItem === '/category' ? styles.active : ''}
                >
                  Categorías
                </DropdownItem>
              )}
              {hasPermission('colors.list') && (
                <DropdownItem
                  tag={RouterLink}
                  to="/colors"
                  className={activeItem === '/colors' ? styles.active : ''}
                >
                  Colores
                </DropdownItem>
              )}
              {hasPermission('comments.list') && (
                <DropdownItem
                  tag={RouterLink}
                  to="/comments"
                  className={activeItem === '/comments' ? styles.active : ''}
                >
                  Comentarios
                </DropdownItem>
              )}
              {hasPermission('providers.list') && (
                <DropdownItem
                  tag={RouterLink}
                  to="/provider"
                  className={activeItem === '/provider' ? styles.active : ''}
                >
                  Mandantes
                </DropdownItem>
              )}
              {hasPermission('brands.list') && (
                <DropdownItem
                  tag={RouterLink}
                  to="/brands"
                  className={activeItem === '/brands' ? styles.active : ''}
                >
                  Marcas
                </DropdownItem>
              )}
              {hasAnyPermission(['settings.view', 'roles.list']) && (
                <DropdownItem
                  tag={RouterLink}
                  to="/settings"
                  className={activeItem === '/settings' ? styles.active : ''}
                >
                  Sistema
                </DropdownItem>
              )}
              {hasPermission('banners.list') && (
                <DropdownItem
                  tag={RouterLink}
                  to="/banners"
                  className={activeItem === '/banners' ? styles.active : ''}
                >
                  Banners
                </DropdownItem>
              )}
              {hasPermission('faqs.list') && (
                <DropdownItem
                  tag={RouterLink}
                  to="/faqs"
                  className={activeItem === '/faqs' ? styles.active : ''}
                >
                  Preguntas Frecuentes
                </DropdownItem>
              )}
              {hasPermission('services.list') && (
                <DropdownItem
                  tag={RouterLink}
                  to="/services"
                  className={activeItem === '/services' ? styles.active : ''}
                >
                  Servicios
                </DropdownItem>
              )}
              {hasPermission('blogs.list') && (
                <DropdownItem
                  tag={RouterLink}
                  to="/blog"
                  className={activeItem === '/blog' ? styles.active : ''}
                >
                  Blog
                </DropdownItem>
              )}
            </DropdownMenu>
          </UncontrolledDropdown>
        )}
      </Nav>

      <div className={styles.footer}>
        <p>
          <strong>Versión:</strong> 1.0.0
        </p>
        <p>
          <strong>Desarrollado por:</strong>{' '}
          <a
            href="https://www.hbsolutions.cl/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Higher Bit Solutions
          </a>
        </p>
      </div>
    </div>
  );
};

export default Sidebar;
